import { EsquireClient } from "@/types/clients/esquire";
import ManualPassportPayload from "@/types/clients/esquire/payloads/post-manual-passport-payload";

export default class PostManualPassport {
  constructor(private client: EsquireClient) {}

  public async send(payload: ManualPassportPayload): Promise<boolean> {
    const url = await this.client.fetchUrlFromSession("manual-passport");

    const response = await this.client.fetch(
      () => new URL(url),
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload.toJson())
      }
    );

    await this.client.logOutIfForbidden(response.status);

    return response.ok;
  }
}
